import React, { useContext, useState, Fragment } from 'react';
import { withStyles } from '@material-ui/core';
import DataContext from '../../data/DataContext';
import more from '../../../asset/img/icon_arrow_down.svg';
import moreDisabled from '../../../asset/img/arr_d_3.svg';
import LeftTail from '../../../asset/img/bubble_point1.png';

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  leftContainer: {
    justifyContent: 'flex-start',
  },
  rightContainer: {
    justifyContent: 'flex-end',
  },
  message: {
    width: '100%',
    fontSize: theme.font.size14,
    margin: '0px 16px 6px 16px',
    flexWrap: 'wrap',
    color: theme.color.message.color,
    zIndex: 10,
    wordWrap: 'break-word',
  },
  leftMessage: {},
  rightMessage: {
    boxShadow: 'none',
  },
  text: {
    margin: '2px 0px 6px 0px',
    borderRadius: '10px',
    backgroundColor: theme.color.message.background,
    minHeight: '44px',
    lineHeight: '1.43',
    padding: '12px 16px',
    flexWrap: 'wrap',
    wordWrap: 'break-word',
  },
  date: {
    color: theme.color.message.date,
    fontSize: theme.font.size11,
    fontWeight: '300',
    alignSelf: 'flex-end',
    margin: '5px 0 6px 0',
    textAlign: 'center',
  },
  typing: {
    width: '30px',
    height: '6px',
  },
  list: {
    alignContent: 'center',
    '& .MuiDivider-root': {
      backgroundColor: '#eee',
    },
  },
  item: {
    width: '100%',
    minHeight: '45px',
    textAlign: 'center',
    color: theme.color.message.color,
    fontSize: theme.font.size14,
    fontWeight: 500,
    padding: '4px 8px',
    margin: '0px',
    backgroundColor: '#fff',
    // outline: '0 none',
    border: 'none',
    borderRight: '1px solid #ddd',
    borderLeft: '1px solid #ddd',
    borderBottom: '1px solid #eee',
    whiteSpace: 'pre-wrap',
    overflow: 'hidden',
    '&:first-child': {
      borderRadius: '6px 6px 0px 0px',
      borderTop: '1px solid #ddd',
    },
    cursor: 'pointer',
    // "&:active": {
    //   backgroundColor: "rgba(38, 38, 38, 0.1)",
    // },
  },
  itemLast: {
    borderRadius: '0px 0px 6px 6px',
    borderBottom: '1px solid #ddd',
  },
  itemDisabled: {
    color: 'rgba(38, 38, 38, 0.4)',
  },
  leftTail: {
    // borderLeft: '14px solid transparent',
    // borderRight: '14px solid transparent',
    // borderTop: '18px solid #fff',
    // borderRadius: '5px',
    zIndex: 11,
    margin: '6px -21px 0px 11px',
    backgroundImage: `url(${LeftTail})`,
    backgroundSize: '21px 12px',
    width: '21px',
    height: '12px',
    minWidth: '21px',
  },
  btnMore: {
    width: 'auto',
    height: '16px',
  },
});

function SL(props) {
  const { classes, data } = props;
  const [showMore, setShowMore] = useState(false);

  const context = useContext(DataContext);

  const handleClick = async (button) => {
    if (button.frontActionFunc) {
      await button.frontActionFunc();
      console.log('access_token is refreshed');
      return;
    }
    console.log('request restart sl');
    context.request(context, button.speech, 'button');
  };

  const handleMore = () => {
    setShowMore(true);
    context.scroll(true);
  };

  const ignoreEndConv = data?.ignoreEndConv ? true : false;

  const maxItem = 5;
  const list = data.list_items && data.list_items.filter((_, index) => index < maxItem);
  const moreList =
    data.list_items &&
    data.list_items.length > maxItem &&
    data.list_items.filter((_, index) => index >= maxItem);

  const disabledCondition = !data.isLast || (!ignoreEndConv && context.conversationEnd);
  return (
    <>
      <div
        className={[
          classes.root,
          data.mine ? classes.rightContainer : classes.leftContainer,
        ].join(' ')}
      >
        <div
          className={[
            classes.message,
            data.mine ? classes.rightMessage : classes.leftMessage,
          ].join(' ')}
        >
          <div role={'text'} className={classes.text} tabIndex={0}>
            {data.text.split('\n').map((content, index) => (
              <Fragment key={index}>
                {content}
                <br />
              </Fragment>
            ))}
          </div>

          <div className={classes.list}>
            {list &&
              list.map((item, index) => (
                <Fragment key={index}>
                  {/* <Divider component={"div"} disabled/> */}
                  <button
                    type="button"
                    className={[
                      classes.item,
                      index === list.length - 1 && !showMore && !moreList
                        ? classes.itemLast
                        : '',
                      disabledCondition && classes.itemDisabled,
                    ].join(' ')}
                    disabled={disabledCondition}
                    onClick={() => handleClick(item)}
                    aria-label={`${item.label}, ${index + 1} / ${
                      moreList ? list.length + moreList.length : list.length
                    }`}
                  >
                    {item.label}
                  </button>
                </Fragment>
              ))}
            {!showMore && moreList && data.list_items.length > maxItem && (
              <Fragment key={'btnMore'}>
                {/* <Divider component={"div"} disabled/> */}
                <button
                  type="button"
                  className={[
                    classes.item,
                    classes.itemLast,
                    disabledCondition && classes.itemDisabled,
                  ].join(' ')}
                  disabled={disabledCondition}
                  onClick={handleMore}
                >
                  <img
                    className={classes.btnMore}
                    src={disabledCondition ? more : moreDisabled}
                    alt="더보기"
                  />
                </button>
              </Fragment>
            )}
            {showMore &&
              data.list_items.length > maxItem &&
              moreList &&
              moreList.map((item, index) => (
                <Fragment key={index}>
                  {/* <Divider component={"div"} disabled/> */}
                  <button
                    type="button"
                    className={[
                      classes.item,
                      index === moreList.length - 1 && classes.itemLast,
                      disabledCondition && classes.itemDisabled,
                    ].join(' ')}
                    disabled={disabledCondition}
                    onClick={() => handleClick(item)}
                    aria-label={`${item.label}, ${index + 1 + list.length} / ${
                      moreList.length + list.length
                    }`}
                  >
                    {item.label}
                  </button>
                </Fragment>
              ))}
          </div>
        </div>
      </div>
    </>
  );
}
export default withStyles(styles)(SL);
